import React from 'react';

import {SettingsFormikContainer} from '~src/settings/components/common/SettingsFormikContainer';
import {SitePrivateConnectSettingsForSiteAdminProps} from '~src/settings/privateconnect-settings/PrivateConnectSettingsCoordinator';

const privateConnectSettingsSections = [
  'PrivateConnectAwsRegionsSection',
];

export interface IPrivateConnectRegionIamRole {
  region: string;
  iamRole: string; // ISO 8601 format: YYYY-MM-DDThh:mm:ssZ
}

export interface ISitePrivateConnectSettingsForSiteAdmin {
  siteId: string;
  siteAdminSettings: ISiteAdminPrivateConnectSettings;
}

export interface ISiteAdminPrivateConnectSettings {
  privateConnectRegionIamRoles: IPrivateConnectRegionIamRole[];
}

export function PrivateConnectSettings(props: SitePrivateConnectSettingsForSiteAdminProps) {

  // const submitHandler = useSubmitHandler(props);

  return <SettingsFormikContainer
    formName={'PrivateConnectSettings'} // this is required
    sections={privateConnectSettingsSections}
    {...props}
  />;
}